import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { Utilities } from 'src/app/models/utilities';
@Component({
    selector: 'app-child-awb',
    templateUrl: './child-awb.component.html',
    styleUrls: ['./child-awb.component.scss']
})

export class ChildAWBComponent {
    @Input() childAWBNoList: any[];

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: true,
    };
    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight',
    };
    columnDefs=[
        { headerName: 'Child Awb No', field: 'awbnumber',pinned:'left' },
        { headerName: 'Status', field: 'status',cellRenderer: Utilities?.status },
      ]

    constructor(
        public activeModal: NgbActiveModal,
        private titleService: Title
    ) { 
        titleService.setTitle('Air Way Bill');
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
    }
}
